import {Hero, HeroType} from '../../layout/Hero'

import {Blocks} from '../../blocks/Blocks'
import {Breadcrumbs} from '../../layout/Breadcrumbs'
import {Layout} from '../../layout/Layout'
import {PageData} from '../../../types'
import React from 'react'
import {style} from '../../../util/style'
import {wrap} from '@codeurs/front'

const styles = style('fullpage')

export type FullpageType = {
	hero: HeroType
}

export const Comingsoon: React.FC<PageData & FullpageType> = wrap(Layout)(
	({...props}) => {
		const {parents, title, hero} = props

		return (
			<div className={styles()}>
				<Hero {...hero} title={(hero && hero.title) || title} />
				<Breadcrumbs parents={parents} title={title} />
				<Blocks
					blocks={[
						{
							type: 'text',
							text:
								'<h2>We werken momenteel aan een vernieuwde webshop.</h2><p>Vanaf <b>maandag 16 december</b> kan je opnieuw materiaal bestellen via <b>webshop.broederlijkdelen.be</b>.<br />Onze excuses voor het ongemak.</p>'
						}
					]}
					container={true}
					fullwidth={true}
				/>
			</div>
		)
	}
)
